<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            결제가&nbsp;
            <span style="color:#F5A21E">{{paymentState}}</span>&nbsp;되었습니다.
          </v-card-title>
          <v-container>
            <v-card-text class="font-weight-medium title">주문 정보</v-card-text>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>주문 번호</td>
                  <td>{{transactionId}}</td>
                </tr>
                <tr>
                  <td>상품명</td>
                  <td>{{paymentInfo.name}}</td>
                </tr>
                <tr>
                  <td>결제 수단</td>
                  <td>{{paymentMethodName}}</td>
                </tr>
                <tr>
                  <td>금액</td>
                  <td>{{amount}}</td>
                </tr>
                <tr v-if="paymentInfo.failedReason">
                  <td>취소 원인</td>
                  <td>{{ paymentInfo.failedReason }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-row align="center" justify="center">
              <v-col align="center" justify="center">
                <h3 v-if="this.paymentInfo.state === PAID_STATE">지금 즉시 리치고 서비스를 경험해보세요!</h3>
                <v-btn color="primary" @click="onClick">확인</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "../mixins/api.js";
import { formUtility } from "../mixins/formUtility.js";

const CANCEL_STATE = 4;
const PAID_STATE = 3;

export default {
  props: {
    transactionId: {
      type: String,
      default() {
        return null;
      }
    }
  },
  async created() {
    await this.getPaymentState();
    if (this.paymentInfo && this.paymentInfo.state === PAID_STATE) {
      this.$ga.ecommerce.addTransaction({
        id: this.transactionId,
        affiliation: "",
        revenue: String(this.paymentInfo.amount),
        shipping: "",
        tax: String(this.tax),
        currency: "KRW"
      });

      this.$ga.ecommerce.addItem({
        id: this.transactionId,
        name: this.paymentInfo.name,
        sku: String(this.paymentInfo.productId),
        category: this.category,
        price: String(this.paymentInfo.amount),
        quantity: "1"
      });
      this.$ga.ecommerce.send();
    }
  },
  computed: {
    paymentMethodName() {
      if (this.paymentInfo.paymentMethod === "card") {
        return "카드";
      } else {
        return this.paymentInfo.paymentMethod;
      }
    },
    amount() {
      if (!this.paymentInfo.amount) {
        return "";
      }
      return this.numberWithCommas(this.paymentInfo.amount.toString()) + "원";
    },
    paymentState() {
      // 우선 결제 상태가 4인 것만 결제 취소 처리한다.
      if (this.paymentInfo.state) {
        return this.paymentInfo.state === CANCEL_STATE ? "취소" : "완료";
      } else {
        return "";
      }
    },
    tax() {
      if (this.paymentInfo.amount && this.paymentInfo.amount > 0) {
        const supplyPrice = (this.paymentInfo.amount / 1.1).toFixed(0);
        const tax = this.paymentInfo.amount - supplyPrice;
        return tax;
      }
      return undefined;
    },
    category() {
      if (this.paymentInfo) {
        if (this.paymentInfo.name.includes("올인원")) {
          return "allinone";
        } else if (this.paymentInfo.name.includes("리포트")) {
          return "report";
        } else {
          return "analysis";
        }
      }
      return "unknown";
    }
  },
  methods: {
    async getPaymentState() {
      const response = await api.methods.getPaymentStateApi(this.transactionId);
      if (response !== null) {
        this.paymentInfo = response;
      } else {
        alert("결제 정보가 없습니다.");
        this.$router.replace("/");
      }
    },
    onClick() {
      if (this.paymentInfo.state === CANCEL_STATE) {
        this.$router.back();
      } else {
        this.$router.push("/");
      }
    }
  },
  data() {
    return {
      paymentInfo: ""
    };
  },
  mixins: [formUtility]
};
</script>
